const imageBaseurl = '';
const imageUrls = {
  logo: imageBaseurl + '/images/new_logo.jpg',
  sihnup: imageBaseurl + '/images/doctor2.png',
  signin: imageBaseurl + '/images/new_doctor.jpg',
  facilities: imageBaseurl + '/images/facilities.svg',
};
export { imageUrls };
